define(['text!./templates/pa-quick-address-address-input-state.html'], (template) => [() => ({
    'restrict': 'A',
    template,
    scope: {
        'model': '=',
        'error': '='
    },
    'controller': ['$scope', ($scope) => {
        $scope.submit = () => {
            $scope.addressForm.submitted = true;
            if ($scope.model.isValid) {
                $scope.model.accept();
            }
        };
    }]
})]);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/address/directives/PAQuickAddressAddressInputState.js
 **/